import { render } from "./ReturnPurchases.vue?vue&type=template&id=6ca93a72"
import script from "./ReturnPurchases.vue?vue&type=script&lang=js"
export * from "./ReturnPurchases.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__